var _path, _path2, _path3, _path4, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 92,
    viewBox: "0 0 75 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1a73e8",
    d: "M10 0h35l20 20v66c0 3.3-2.7 6-6 6H10c-3.3 0-6-2.7-6-6V6c0-3.3 2.7-6 6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8f0fe",
    d: "M45 0v14c0 3.3 2.7 6 6 6h14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8f0fe",
    d: "M17 36h41v4H17zm0 12h41v4H17zm0 12h26v4H17z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b57d0",
    d: "M10 0h35l20 20v2.5H51c-4.1 0-7.5-3.4-7.5-7.5V0z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 37.5,
    y: 69,
    fill: "#ffffff",
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    textAnchor: "middle"
  }, "DOC")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.e06776f471cc5bafbbaa3fdb5edb7723.svg";
export { ForwardRef as ReactComponent };